import { FC } from "react";
import { B2Card } from "@hdb/biome-2";
import "./info-tile.scss";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface DashboardStatisticsProps {
  header: string;
  children: any;
  minHeight?: string;
  floorplanButtonStatus?: boolean;
  floorplanNavigateFunction?: () => void;
}

const InfoTileContainer: FC<DashboardStatisticsProps> = ({
  header,
  children,
  minHeight,
  floorplanButtonStatus,
  floorplanNavigateFunction,
}) => {

  return (
    <B2Card
      className="card-bg"
      style={{ minHeight: minHeight || "" }}
    >
      <B2Card.Header className="fs-5 fw-bold header-bg">
        {/* {header} */}
        {header === "Asset Details" && floorplanNavigateFunction ?
          <div className="d-flex justify-content-between align-items-center gap-1">
            {header}
            <button
              type="button"
              className="d-flex align-items-center gap-1 fw-bold"
              title={floorplanButtonStatus ? "Floor Plan" : "Asset Not Annotated "}
              onClick={() => {
                if (floorplanNavigateFunction && floorplanButtonStatus) {
                  floorplanNavigateFunction();
                }
              }}
              disabled={!floorplanButtonStatus}
              aria-disabled={!floorplanButtonStatus}
              style={{
                cursor: floorplanButtonStatus ? "pointer" : "not-allowed",
                opacity: floorplanButtonStatus ? 1 : 0.5,
                color: floorplanButtonStatus ? "inherit" : "#999",
                border: "none",
                backgroundColor: "transparent",
                padding: 0,
              }}
            >
              <FontAwesomeIcon
                icon={faEye}
                className="fs-7 me-2"
              />
              <span>Floor Plan</span>
            </button>

          </div> : header}



      </B2Card.Header>
      <B2Card.Body>
        <B2Card.Text as="div">{children}</B2Card.Text>
      </B2Card.Body>
    </B2Card>
  );
};

export default InfoTileContainer;
